// extracted by mini-css-extract-plugin
export default {"title":"refs_title__2zXh4","btn":"refs_btn__dvC3L","icon":"refs_icon__F0YIo","id":"refs_id__NYFLt","label":"refs_label__nl9eU","value":"refs_value__tTuJk","text":"refs_text__P5wDu"};